import { FormEvent, KeyboardEvent } from 'react'

import { TextArea } from '@avantstay/backoffice-core'

import * as S from '../MessageComposer.styles'
import { isSubmitShortcut } from '../MessageComposer.utils'

interface NoteComposerProps {
  draft: string
  isAddingNote: boolean
  onDraftChange: (draft: string) => void
  onAddNote: (body: string) => Promise<boolean>
}

export const NoteComposer = ({
  draft,
  isAddingNote,
  onDraftChange,
  onAddNote,
}: NoteComposerProps) => {
  const canAdd = !!draft.trim() && !isAddingNote

  const addNote = async () => {
    if (!canAdd) return

    const success = await onAddNote(draft)
    if (success) onDraftChange('')
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLFormElement>) => {
    if (!isSubmitShortcut(event)) return

    event.preventDefault()
    void addNote()
  }

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    void addNote()
  }

  return (
    <form onKeyDown={handleKeyDown} onSubmit={handleSubmit}>
      <TextArea
        rows={3}
        placeholder="Add a note for your team…"
        value={draft}
        disabled={isAddingNote}
        onChange={event => onDraftChange(event.target.value)}
      />

      <S.Actions>
        <S.Details>
          <S.Hint>Only your team can see this.</S.Hint>
        </S.Details>

        <S.SubmitButton type="submit" disabled={!canAdd} loading={isAddingNote}>
          Add note
        </S.SubmitButton>
      </S.Actions>
    </form>
  )
}
